import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({
      id: 'routingLayout.extractedMapWarningModal.header.title',
    }),
  }))

  return api
}
